import "flag-icons/css/flag-icons.min.css";


interface IFlagIcon {
    locale: string
}

let FlagIcon = (props: IFlagIcon) => {
    return (
        <span className={`fi fi-${props.locale.substring(props.locale.lastIndexOf('-') + 1).toLowerCase()}`}></span>
    );
}

export default FlagIcon;